import { createAction } from 'redux-actions';
import { actionKey } from './constants';
import { flagsFromSession } from './helpers';
export var initFlags = createAction(actionKey + ".INIT_FLAGS", function (_a) {
    var features = _a.features;
    return ({ flags: flagsFromSession(features) });
});
export var setFlags = createAction(actionKey + ".SET_FLAGS", function (flags) { return ({ flags: flags }); });
//# sourceMappingURL=actions.js.map